// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mZMJJ.ui.label{align-items:center;background-color:#0000;border:1px solid #0000;cursor:default;display:inline-flex;gap:.4rem;white-space:nowrap}.xuivY{flex-shrink:0;height:1em;width:1em}.gN5vr.ui.label{background-color:color-mix(in srgb,#db2828 12%,#0000);border-color:color-mix(in srgb,#db2828 45%,#0000);color:#db2828}:root[data-darkreader-scheme=dark] .gN5vr.ui.label{background-color:#db28281f;border-color:#db282866;color:#e08484}.DA6lu.ui.label{background-color:color-mix(in srgb,#21ba45 12%,#0000);border-color:color-mix(in srgb,#21ba45 45%,#0000);color:#21ba45}:root[data-darkreader-scheme=dark] .DA6lu.ui.label{background-color:#21ba451f;border-color:#21ba4566;color:#21ba45}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `mZMJJ`,
	"icon": `xuivY`,
	"impacted": `gN5vr`,
	"notImpacted": `DA6lu`
};
module.exports = ___CSS_LOADER_EXPORT___;
